import React from "react";
import { Link } from "react-router-dom";
import { catalogLink } from "../lib/api";
import { resolvePopularImage } from "../mock";

function MenuLink({ item }) {
  const internalPaths = {
    "appliance-model-lookup": "/model-lookup",
    "product-brands": "/marques",
    "cant-find-a-part": "/contact",
  };
  const internal = internalPaths[item.slug];

  if (internal) {
    return (
      <Link
        to={internal}
        className="block py-1 text-sm text-slate-700 hover:text-rp-green hover:underline"
      >
        {item.name}
      </Link>
    );
  }

  if (item.is_link_only && item.href) {
    return (
      <a
        href={item.href}
        target="_blank"
        rel="noopener noreferrer"
        className="block py-1 text-sm text-slate-700 hover:text-rp-green hover:underline"
      >
        {item.name}
      </a>
    );
  }

  return (
    <Link
      to={catalogLink({ menu: item.slug })}
      className="block py-1 text-sm text-slate-700 hover:text-rp-green hover:underline"
    >
      {item.name}
      {item.product_count > 0 && (
        <span className="text-slate-400 ml-1">({item.product_count.toLocaleString()})</span>
      )}
    </Link>
  );
}

function PopularItem({ item }) {
  const imageSrc = resolvePopularImage(item);
  return (
    <Link
      to={catalogLink({ menu: item.slug })}
      className="group flex flex-col gap-2"
    >
      <div className="aspect-[4/3] bg-white border border-slate-200 rounded overflow-hidden flex items-center justify-center p-2">
        {imageSrc ? (
          <img
            src={imageSrc}
            alt={item.name}
            className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform"
            loading="lazy"
          />
        ) : (
          <div className="text-xs text-slate-400 text-center px-2">{item.name}</div>
        )}
      </div>
      <span className="text-sm font-medium text-slate-800 group-hover:text-rp-green group-hover:underline leading-snug">
        {item.name}
      </span>
    </Link>
  );
}

export default function ProductsMegaMenu({ sections, onNavigate }) {
  if (!sections?.length) return null;

  return (
    <div className="absolute left-0 right-0 top-full bg-[#f5f5f5] border-t border-slate-300 shadow-xl z-50">
      <div className="max-w-[1400px] mx-auto px-6 py-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {sections.map((section) => (
            <div key={section.slug}>
              <h3 className="text-rp-green font-bold text-base mb-3 pb-1 border-b border-slate-300">
                {section.name}
              </h3>

              {section.type === "popular" ? (
                <div className="grid grid-cols-2 gap-4">
                  {section.items.map((item) => (
                    <div key={item.slug} onClick={onNavigate}>
                      <PopularItem item={item} />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="space-y-0.5">
                  {section.items.map((item) => (
                    <div key={item.slug} onClick={onNavigate}>
                      <MenuLink item={item} />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
